import { NgClass, NgStyle } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { Accordion } from 'primeng/accordion';

@Component({
  selector: 'iu-prime-accordion',
  templateUrl: './prime-accordion.component.html',
  providers: [{ provide: Accordion, useExisting: PrimeAccordionComponent }],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgClass, NgStyle],
})
export class PrimeAccordionComponent extends Accordion {
  override onTabHomeKey(): void {
    // no-op: disable parent keyboard navigation
  }
  override onTabEndKey(): void {
    // no-op: disable parent keyboard navigation
  }
}
